import { ModelPath } from "../../../../../../Common/ModelPath/ModelPath";
import { IEvaluationContext } from "../IEvaluationContext";
import { IterationContext } from "../ModelPath/IterationContext";

import { CalculationActionDecorator, IExecutionPlanStep } from "./ExecutionPlanStep";

export class PushIterationContextExecutionPlanStep implements IExecutionPlanStep {
    private readonly instance: string;
    private readonly pathToList: ModelPath;

    public constructor(pathToList: ModelPath, instance: string) {
        this.instance = instance;
        this.pathToList = pathToList;
    }

    public getStepExecutor(): CalculationActionDecorator {
        return action =>
            (context: IEvaluationContext): void | Promise<void> =>
                action(context.pushIterationContext(new IterationContext(this.pathToList, this.instance)));
    }

    public toDebugString(): string {
        return `take(${this.pathToList}/${this.instance})`;
    }
}
